import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setUIForwardAction } from '../../actions'
import { setIsShowTimeOutMessageAction } from '../../actions/ui'
import { UI } from '../../constants/ui'
import { INACTIVITY_COUNTDOWN_SEC } from '../../constants/timeoutmessage'
import './timeoutmessage.less'
import { setReservationIdAction, setDriver1BirthDateAction } from '../../actions/'

const mapDispatchToProps = {
  setUI: setUIForwardAction,
  setIsShowTimeOutMessage: setIsShowTimeOutMessageAction,
  setReservationId: setReservationIdAction,
  setDriver1BirthDate: setDriver1BirthDateAction,
}

type DispatchProps = typeof mapDispatchToProps

const TimeOutMessage: React.FC<DispatchProps> = ({
  setUI,
  setIsShowTimeOutMessage,
  setReservationId,
  setDriver1BirthDate,
}: DispatchProps) => {
  const { t } = useTranslation()
  const [timeLeft, setTimeLeft] = useState(INACTIVITY_COUNTDOWN_SEC)

  const continueUserSession = () => {
    setIsShowTimeOutMessage(false)
  }

  const backHomePage = () => {
    setReservationId('')
    setDriver1BirthDate('')
    setIsShowTimeOutMessage(false)
    setUI(UI.MAIN)
  }

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft((i) => i - 1), 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="timeoutmessage">
      <div className="timeoutmessage-background">
        <div className="timeoutmessage-center">
          <div className="timeoutmessage-title">{t('wantToContinueCheckIn')}</div>
          <div className="timeoutmessage-label">
            {t('yourSessionWillTimeOutIn')}{' '}
            <span>
              {timeLeft >= 0 ? timeLeft : backHomePage()} {t('seconds')}
            </span>
          </div>
          <div className="timeoutmessage-buttons">
            <button className="cancel-button" onClick={() => backHomePage()}>
              {t('no')}, {t('exit')}
            </button>
            <button className="main-button" onClick={() => continueUserSession()}>
              {t('yes')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default connect(
  null,
  mapDispatchToProps,
)(TimeOutMessage)
